import { useState } from 'react';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createSegment } from '../../data';
import { Wrapper, Title } from '../../../../shared/ModalComponents';
import { Button } from '../../../../shared/FormStyles/Button';
import { ModalButtonGroup } from '../StyledComponents';
import { BaseInput as Input, Label } from '../../../../shared/FormStyles';
import Modal from '../../../../shared/Modal';
import { useNotification } from '../../../../shared/Notification/useNotification';
import defaultAttrs from '../../../../lib/utils/defaultAttrs';

const NewSegmentIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-solid fa-plus',
  }),
)`
  margin: 0 0 0 6px;
`;

const InputWrapper = styled.div`
  margin: 0 0 24px;
  width: 100%;
`;

const SegmentForm = ({ onCancel, onConfirm }) => {
  const [segmentName, setSegmentName] = useState('');

  return (
    <Wrapper>
      <Title>Create Population Segment</Title>
      <InputWrapper>
        <Label>Population Segment Name</Label>
        <Input
          id="population_segment_name"
          type="text"
          placeholder="Name"
          onChange={e => setSegmentName(e.target.value)}
          value={segmentName}
        />
      </InputWrapper>
      <ModalButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="containedBlue"
          ml="8px"
          onClick={() => onConfirm({ segmentName })}
          disabled={segmentName.length === 0}
        >
          Create
        </Button>
      </ModalButtonGroup>
    </Wrapper>
  );
};

const CreateSegmentButton = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('shared');
  const { showError } = useNotification();

  const { mutate: createSegmentMutation } = useMutation(createSegment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['populationSegments']);
      Swal.close();
    },
    onError: () => {
      showError({ content: t('errorText') });
    },
  });

  const modalForm = () => {
    Modal({
      component: (
        <SegmentForm
          onCancel={() => Swal.clickCancel()}
          onConfirm={createSegmentMutation}
        />
      ),
      width: '394px',
      padding: '24px',
      showConfirmButton: false,
    });
  };

  return (
    <Button onClick={modalForm} variant="outlinedBlue">
      Create Population Segment <NewSegmentIcon />
    </Button>
  );
};

export default CreateSegmentButton;
